<div class="contenedor">
  <div class="w3-col s4 contenedorLeft">
    <div class="w3-center">
      <img src="./../../../assets/img/logoB.png" alt="">
      <br>
      <b class="w3-text-white w3-frase slogan">Quien todo lo sabe</b>
    </div>
    <div class="w3-text-white w3-frase slogan"></div>
  </div>
  <div class="w3-col s8 w3-white flexContent" style="height: 100%;">
    <div class="container">
      <div class="w3-col s5">
        <span class="textoTit"><b>Recuperar contrase&ntilde;a</b></span>
        <form [formGroup]="formForgotPass" (submit)="forgotPass()" style="margin-top: 2vh;">
          <mat-form-field appearance="outline">
            <input formControlName="email" matInput required type="email">
            <mat-icon matPrefix style="color: grey;">face</mat-icon>
            <mat-label>Correo electrónico</mat-label>
            @if (formForgotPass.controls['email'].hasError('required')) {
              <mat-error>Campo <strong>requerido</strong></mat-error>
            }
            @if (formForgotPass.controls['email'].hasError('email')) {
              <mat-error>Correo <strong>invalido</strong></mat-error>
            }
          </mat-form-field>
        
          <div class="w3-row w3-right">
            <button class="button2 borderTest" (keydown.enter)="$event.preventDefault()" routerLink='/'> <b>Cancelar</b> </button>
            <button class="button borderTest" (keydown.enter)="$event.preventDefault()" type="submit"> <b>ENVIAR</b> </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>